import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { OrderLifetimeRuleAction } from '../orderLifetimeRule.action';
import { OrderLifetimeRuleTranslator } from '../orderLifetimeRule.translator';

type IDependencies = IClientApiDependencySegment;

export const loadOrderLifetimeRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeRuleAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getOrderLifetimeRules().pipe(
      mergeMap((response) => {
        const result = (response.rules ?? []).map(OrderLifetimeRuleTranslator.fromApi);

        return [
          OrderLifetimeRuleAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeRuleAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
